const BLOCK_RIZ_CONFIG = {
  discardIfOlderThan: 30,
  blockIfOlderThan: 14,
};

export default BLOCK_RIZ_CONFIG;
